import React from 'react'
import {SuspenseWhileLoading} from '@oc/components'

const RkConfig = React.lazy(async () => ({
    default: (await import('@oc/rk-config/module')).RkConfig
}))

export function RkConfigComponent() {
    return <SuspenseWhileLoading LazyComponent={RkConfig} />
}
